var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eg-b-container',{staticClass:"mt-3"},[_c('eg-b-alert',{attrs:{"variant":"warning","show":""}},[_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.clientDisabledMessage)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }